import type { OutpatientClinicTask } from '@common/contexts/support/domain/models/outpatientClinicTaskModel';
import type { IEpisodeCategory } from '@common/interfaces';
import { OutpatientClinic } from '@frontend/components/pages/outpatientClinic/constants/apiEndpoints';
import { postJson } from '@frontend/store/fetch';

export type FetchOutpatientClinicTasksMetadataProps = {
    abortSignal: AbortSignal;
};

export async function fetchOutpatientClinicTasksMetadata({
    abortSignal,
}: FetchOutpatientClinicTasksMetadataProps): Promise<{
    episodeCategories: IEpisodeCategory[];
    practitioners: NonNullable<OutpatientClinicTask['performerPractitioner']>[];
    professions: NonNullable<OutpatientClinicTask['performerPractitionerProfession']>[];
    types: OutpatientClinicTask['type'][];
}> {
    const response = await postJson(`${OutpatientClinic.TasksMetadata}`, {}, abortSignal);

    return response.json;
}
